module.exports = __webpack_public_path__ + "static/22-c3d966c3c9c4212b94a2b0ad28634fb7.png";